import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ContactModal } from "./ContactModal";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { WorkflowIcon } from "./WorkflowIcon";
import { useContactModal } from "../context/contactModal";
import { DATA_WORKFLOW_STEPS, SOLUTIONS } from "../data/solutions";
export function CatalogLayout({ children }) {
  const { isOpen, closeModal } = useContactModal();
  return (
    <div className="catalog-site">
      <Header forceLight={true} />
      <main id="main">{children}</main>
      <Footer />
      <ContactModal isOpen={isOpen} onClose={closeModal} />
    </div>
  );
}
export function CatalogCta() {
  const { openModal } = useContactModal();
  return (
    <section className="catalog-cta">
      <div className="catalog-wrap">
        <div>
          <p className="catalog-kicker">Build with Actrium</p>
          <h2>Start with your task.</h2>
          <p>Define the devices, data and evaluation your project needs.</p>
        </div>
        <button className="catalog-button" onClick={openModal}>
          Discuss your project
        </button>
      </div>
    </section>
  );
}
export function CatalogHero({ label, title, intro }) {
  return (
    <section className="catalog-wrap catalog-hero">
      <p className="catalog-kicker">{label}</p>
      <h1>{title}</h1>
      <p className="catalog-lead">{intro}</p>
    </section>
  );
}
export function ProductGrid({ products }) {
  return (
    <div className="catalog-grid">
      {products.map((t) => (
        <Link className="catalog-card" to={`/products/${t.slug}`} key={t.slug}>
          <img src={t.image} alt={`${t.name} ${t.imageNote}`} loading="lazy" />
          <div>
            <p className="catalog-kicker">
              {t.category} / {t.status}
            </p>
            <h3>{t.name}</h3>
            <p>{t.subtitle}</p>
            <dl className="product-card-specs">
              {t.metrics.slice(0, 3).map(([n, r]) => (
                <div key={r}>
                  <dt>{r}</dt>
                  <dd>{n}</dd>
                </div>
              ))}
            </dl>
            <span className="catalog-text-link">
              View Details <ArrowRight size={18} />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}
export function SolutionCards() {
  return (
    <div className="catalog-grid">
      {SOLUTIONS.map((e) => (
        <Link className="catalog-card" to={`/solutions/${e.slug}`} key={e.slug}>
          <img src={e.image} alt={e.imageNote} loading="lazy" />
          <div>
            <h3>{e.name}</h3>
            <p>{e.heading}</p>
            <span className="catalog-text-link">Explore solution →</span>
          </div>
        </Link>
      ))}
    </div>
  );
}
export function DataWorkflow() {
  return (
    <div className="catalog-workflow">
      {DATA_WORKFLOW_STEPS.map(([e, t], n) => (
        <article key={e}>
          <WorkflowIcon
            name={["capture", "align", "compiler", "model", "benchmark"][n]}
            className="h-7 w-7"
          />
          <h3>{e}</h3>
          <p>{t}</p>
        </article>
      ))}
    </div>
  );
}
export function FeatureList({ items }) {
  return (
    <div className="catalog-features">
      {items.map(([t, n]) => (
        <article key={t}>
          <h3>{t}</h3>
          <p>{n}</p>
        </article>
      ))}
    </div>
  );
}
